"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldWithStateAndDebounce = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_1 = __importStar(require("react"));
const TextField_1 = __importDefault(require("../TextField"));
function TextFieldWithStateAndDebounce(props) {
    const { debounce = 300, type, value = '', onChange = doNothing_1.default } = props, otherProps = __rest(props, ["debounce", "type", "value", "onChange"]);
    const [currentValue, setCurrentValue] = (0, react_1.useState)(value || '');
    const handleCallback = (0, react_1.useMemo)(() => (0, debounce_1.default)(v => {
        if (type === 'number ' && !!v)
            onChange(parseFloat(v));
        else
            onChange(v);
    }, debounce, { leading: false, trailing: true }), [onChange, debounce, type]);
    const handleChange = (0, react_1.useCallback)(v => {
        setCurrentValue(v);
        handleCallback(v);
    }, [handleCallback]);
    (0, react_1.useEffect)(() => setCurrentValue(value), [value]);
    return react_1.default.createElement(TextField_1.default, Object.assign({ value: currentValue, onChange: handleChange }, otherProps));
}
exports.TextFieldWithStateAndDebounce = TextFieldWithStateAndDebounce;
exports.default = TextFieldWithStateAndDebounce;
